export enum NavigationTier {
  System,
  Institution,
  Unit,
  Scholar,
  Ignore,
}
